<template>
    <div>
        <div class="row" v-if="process_type_id==1">
            <div class="col-lg-6 col-xs-12">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">@</span>
                    </div>
                    <input type="text" class="form-control" placeholder="Usuario" name="user" id="user" v-model="user">
                    <div class="input-group-append">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            icon
                            @click="save_word('user')"
                            color="accent"
                          ><v-icon>
                            mdi-content-save
                          </v-icon></v-btn>
                        </template>
                        <span>Guardar</span>
                      </v-tooltip>
                    </div>
                </div><!-- /input-group -->
            </div><!-- /.col-lg-6 -->
        </div>
        <div class="row" v-if="process_type_id==2">
            <div class="col-lg-6 col-xs-12">
                <div class="input-group">
                    <input type="text" class="form-control" placeholder="Palabra Padre" name="parent" id="parent" v-model="parent">
                    <span class="input-group-btn">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            icon
                            @click="save_word('parent')"
                            color="accent"
                          ><v-icon>
                            mdi-content-save
                          </v-icon></v-btn>
                        </template>
                        <span>Guardar</span>
                      </v-tooltip>
                    </span>
                </div>
            </div>
            <div class="col-lg-6 col-xs-12">
                <div class="input-group">
                    <input type="text" class="form-control" placeholder="Palabra Hija" name="child" id="child"  v-model="child">
                    <span class="input-group-btn">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            icon
                            @click="save_word('child')"
                            color="accent"
                          ><v-icon>
                            mdi-content-save
                          </v-icon></v-btn>
                        </template>
                        <span>Guardar</span>
                      </v-tooltip>
                    </span>
                </div>
            </div>
        </div>
        <br>


        <template v-if="process_type_id==1">
          <v-row>
            <v-col md="6">
              <v-data-table
                :headers="h_users"
                :items="users"
                hide-default-footer
                disable-pagination
                class="elevation-1"
              >
                <template v-slot:item.acciones="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        icon
                        @click="delete_word(item.id)"
                        color="error"
                      >
                        <v-icon>
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Eliminar palabra</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </template>
        <template v-if="process_type_id==2">
          <v-row>
            <v-col md="12">
              <v-data-table
                :headers="h_parent_child"
                :items="words"
                hide-default-footer
                disable-pagination
                class="elevation-1"
              >
                <template v-slot:item.accionespadre="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        icon
                        @click="delete_word(item.parent_id)"
                        color="error"
                      >
                        <v-icon>
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Eliminar palabra</span>
                  </v-tooltip>
                </template>
                <template v-slot:item.accioneshija="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        icon
                        @click="delete_word(item.child_id)"
                        color="error"
                      >
                        <v-icon>
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Eliminar palabra</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </template>
    </div>
</template>

<script>
import apiExtract from "@/api/modules/extract";
import store from '@/store';
let organization_id = store.getters['auth/org'];

export default {
    data(){
        return {
            user:null,
            users: [],
            h_users:[
              {
                text: 'Usuario',
                align: 'start',
                sortable: false,
                value: 'palabra',
              },
              {
                text: 'Acciones',
                sortable: false,
                align: 'right',
                value: 'acciones',
              },
            ],
            h_parent_child:[
              {
                text: 'Palabra Padre',
                align: 'start',
                sortable: false,
                value: 'parent',
              },
              {
                text: 'Acciones',
                sortable: false,
                align: 'right',
                value: 'accionespadre',
              },
              {
                text: 'Palabra Hija',
                sortable: false,
                align: 'left',
                value: 'child',
              },
              {
                text: 'Acciones',
                sortable: false,
                align: 'right',
                value: 'accioneshija',
              },
            ],
            parent:null,
            child:null,
            words:[],
            unsaved:[],
            status_count:0,
            status_target:0

        }
    },
    props: {
      process_id:{type:String},
      schedule_id:{type:Number},
      process_type_id:{type:Number,required:true}
    },
    mounted(){
        //llamando al api
        apiExtract.getWords(organization_id, this.schedule_id)
        .then((resp)=>{
            this.processWords(resp);
        })
    },
    watch:{
      status_count(val){
        if (val==this.status_target && val!=0){
          this.$emit('status_true');
        }
      },
    },
    methods:{
        processWords(resp){
            var functionWords = [];
            var parents = [];
            var childs = [];
            let count = 0;
            if(resp.status){
                if(this.process_type_id==1){
                    this.users = resp.words;
                }
                if(this.process_type_id==2){
                    resp.words.forEach(element => {
                        if(element.tipo_palabra_id==2){
                            parents.push({id:element.id, word:element.palabra});
                        }
                        if(element.tipo_palabra_id==3){
                            childs.push({id:element.id, word:element.palabra});
                        }
                    });
                    count = (childs.length > parents.length)?childs.length:parents.length;
                    for (let index = 0; index < count; index++) {
                        functionWords.push({parent_id: (typeof parents[index] !== 'undefined')?parents[index]['id']:null, parent:(typeof parents[index] !== 'undefined')?parents[index]['word']:null, child_id: (typeof childs[index] !== 'undefined')?childs[index]['id']:null, child:(typeof childs[index] !== 'undefined')?childs[index]['word']:null})
                    }
                }
                this.words = functionWords;
            }
        },
        save_word(type){
            let word = '';
            let word_type_id = '';
            switch (type) {
                case "user":
                    word = this.user;
                    word_type_id = 1;
                    break;
                case "parent":
                    word = this.parent;
                    word_type_id = 2;
                    break;
                case "child":
                    word = this.child;
                    word_type_id = 3;
                    break;
            }
            if(this.schedule_id==0){
              this.unsaved=this.unsaved.concat({
                "palabra": word,
                "tipo_palabra_id": word_type_id
              })
              this.processWords({status:true,words:this.unsaved});
              this.user = '';
              this.child = '';
              this.parent = '';

            }else{
              apiExtract.postWord(organization_id, this.process_id, this.schedule_id, word, word_type_id)
              .then((resp)=>{
                  this.processWords(resp);
                  this.user = '';
                  this.child = '';
                  this.parent = '';
              })
            }
        },
        delete_word(word_id){
            apiExtract.deleteWord(organization_id, this.schedule_id, word_id)
            .then((resp)=>{
                this.processWords(resp);
            })
        },
        save_words(process_id,schedule_id){
          this.status_count=0
          this.status_target=this.unsaved.length
          let arreglo = []
          for (var i in this.unsaved) {
            arreglo.push(apiExtract.postWord(organization_id, process_id, schedule_id, this.unsaved[i].palabra, this.unsaved[i].tipo_palabra_id))
          }
          apiExtract.postWords(arreglo)
          .then(()=>{
            this.$router.push('/process/'+process_id);
          })
        },
    }
}
</script>
